// extracted by mini-css-extract-plugin
module.exports = {"formItem":"render-boolean_formItem_1D3tq","label":"render-boolean_label_gpY5Z","labelHeader":"render-boolean_labelHeader_26Mev"};